var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "courses"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29487",
    "data-name": "Rectangle 29487",
    width: 14,
    height: 14,
    transform: "translate(39 264)",
    fill: "#6a6f73",
    stroke: "#8391a2",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_706",
    "data-name": "Mask Group 706",
    transform: "translate(-39 -264)",
    clipPath: "url(#courses)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_11_",
    "data-name": "svgexport-6 (11)",
    transform: "translate(39 264.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12940",
    "data-name": "Path 12940",
    d: "M8.652,6.406a.273.273,0,1,0-.273-.273A.274.274,0,0,0,8.652,6.406Zm0,0",
    transform: "translate(-0.559 -0.391)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12941",
    "data-name": "Path 12941",
    d: "M8.652,8.164a.273.273,0,1,0-.273-.273A.274.274,0,0,0,8.652,8.164Zm0,0",
    transform: "translate(-0.559 -0.508)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12942",
    "data-name": "Path 12942",
    d: "M2.617,4.648a.273.273,0,1,0-.273-.273A.274.274,0,0,0,2.617,4.648Zm0,0",
    transform: "translate(-0.156 -0.273)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12943",
    "data-name": "Path 12943",
    d: "M2.617,6.406a.273.273,0,1,0-.273-.273A.274.274,0,0,0,2.617,6.406Zm0,0",
    transform: "translate(-0.156 -0.391)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12944",
    "data-name": "Path 12944",
    d: "M2.617,8.164a.273.273,0,1,0-.273-.273A.274.274,0,0,0,2.617,8.164Zm0,0",
    transform: "translate(-0.156 -0.508)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12945",
    "data-name": "Path 12945",
    d: "M13.727,1.094h-.82V.273A.273.273,0,0,0,12.633,0H8.094A1.366,1.366,0,0,0,7,.548,1.366,1.366,0,0,0,5.906,0H1.367a.273.273,0,0,0-.273.273v.82H.273A.273.273,0,0,0,0,1.367v9.3a.273.273,0,0,0,.273.273H5.23a.816.816,0,0,1,.734.453,1.158,1.158,0,0,0,2.072,0,.816.816,0,0,1,.734-.454h4.957A.273.273,0,0,0,14,10.664v-9.3a.273.273,0,0,0-.273-.273ZM8.094.547h4.266V9.3H8.094a1.361,1.361,0,0,0-.82.274v-8.2a.821.821,0,0,1,.82-.82Zm-4.813,0H4.375v1.4l-.4-.264a.273.273,0,0,0-.3,0l-.4.264Zm-1.641,0H2.734V2.461a.273.273,0,0,0,.425.228l.669-.446.669.446a.273.273,0,0,0,.425-.228V.547h.984a.821.821,0,0,1,.82.82v8.2a1.36,1.36,0,0,0-.82-.274H1.641Zm11.813,9.844H8.77a1.36,1.36,0,0,0-1.223.756.611.611,0,0,1-1.094,0,1.36,1.36,0,0,0-1.223-.756H.547V1.641h.547V9.57a.273.273,0,0,0,.273.273H5.906a.821.821,0,0,1,.82.82.273.273,0,0,0,.547,0,.821.821,0,0,1,.82-.82h4.539a.273.273,0,0,0,.273-.273V1.641h.547Zm0,0",
    fill: "#6a6f73",
    stroke: "#8391a2",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12946",
    "data-name": "Path 12946",
    d: "M8.652,4.531H12.1a.273.273,0,0,0,.273-.273V2.617a.273.273,0,0,0-.273-.273H8.652a.273.273,0,0,0-.273.273V4.258A.273.273,0,0,0,8.652,4.531Zm.273-1.641h2.9V3.984h-2.9Zm0,0",
    transform: "translate(-0.559 -0.156)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12947",
    "data-name": "Path 12947",
    d: "M3.789,4.648H6.141a.273.273,0,1,0,0-.547H3.789a.273.273,0,1,0,0,.547Zm0,0",
    transform: "translate(-0.234 -0.273)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12948",
    "data-name": "Path 12948",
    d: "M3.789,6.406H6.141a.273.273,0,1,0,0-.547H3.789a.273.273,0,1,0,0,.547Zm0,0",
    transform: "translate(-0.234 -0.391)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12949",
    "data-name": "Path 12949",
    d: "M3.789,8.164H6.141a.273.273,0,1,0,0-.547H3.789a.273.273,0,1,0,0,.547Zm0,0",
    transform: "translate(-0.234 -0.508)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12950",
    "data-name": "Path 12950",
    d: "M12.176,5.859H9.824a.273.273,0,0,0,0,.547h2.352a.273.273,0,0,0,0-.547Zm0,0",
    transform: "translate(-0.637 -0.391)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12951",
    "data-name": "Path 12951",
    d: "M12.176,7.617H9.824a.273.273,0,0,0,0,.547h2.352a.273.273,0,0,0,0-.547Zm0,0",
    transform: "translate(-0.637 -0.508)",
    fill: "#6a6f73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.00467d53f4b22345d686d4038a0fb8c4.svg";
export { ForwardRef as ReactComponent };